import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideCircleCheck, lucideTriangleAlert } from '@ng-icons/lucide';
import { HlmAlertImports } from '@spartan-ng/helm/alert';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmSkeletonImports } from '@spartan-ng/helm/skeleton';
import { LogoComponent } from '../../components/logo/logo.component';
import { PartnerService } from '../../services/partner.service';

type State = 'checking' | 'confirmed' | 'failed';

/** /partner/verify-email?token=… from the mail after a password sign-up. */
@Component({
  selector: 'app-partner-verify-email',
  standalone: true,
  imports: [
    RouterModule,
    NgIcon,
    HlmAlertImports,
    HlmButtonImports,
    HlmCardImports,
    HlmSkeletonImports,
    LogoComponent,
  ],
  providers: [provideIcons({ lucideCircleCheck, lucideTriangleAlert })],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './partner-verify-email.component.html',
})
export class PartnerVerifyEmailComponent {
  readonly state = signal<State>('checking');
  readonly error = signal('');

  constructor() {
    const token = inject(ActivatedRoute).snapshot.queryParamMap.get('token');
    if (!token) {
      this.fail('Der Link ist unvollständig.');
      return;
    }
    inject(PartnerService)
      .verifyEmail(token)
      .subscribe({
        next: () => this.state.set('confirmed'),
        error: (err: HttpErrorResponse) =>
          this.fail(
            err.status === 400
              ? (err.error?.detail ?? 'Der Link ist ungültig oder abgelaufen.')
              : 'Der Link konnte nicht geprüft werden. Bitte lade die Seite neu.',
          ),
      });
  }

  private fail(message: string): void {
    this.error.set(message);
    this.state.set('failed');
  }
}
